import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CustomerTableRow = ({ customer, onClick, canEdit = true, canDelete = true }) => {
  const getStatusColor = (status) => {
    const colors = {
      inquiry: 'bg-primary/8 text-primary border border-primary/20',
      planning: 'bg-secondary/10 text-secondary border border-secondary/20',
      permits: 'bg-accent/10 text-accent border border-accent/20',
      construction: 'bg-warning/10 text-warning border border-warning/20',
      completed: 'bg-success/10 text-success border border-success/20'
    };
    return colors?.[status] || colors?.inquiry;
  };

  const getAduTypeLabel = (type) => {
    const labels = {
      detached: 'Detached',
      attached: 'Attached',
      garage_conversion: 'Garage Conv.',
      basement_conversion: 'Basement Conv.'
    };
    return labels?.[type] || type;
  };

  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <tr 
      onClick={onClick}
      className="border-b border-border hover:bg-muted/50 cursor-pointer transition-colors duration-200"
    >
      <td className="px-4 md:px-6 py-4 md:py-5">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-muted">
            <Image
              src={customer?.avatar}
              alt={customer?.avatarAlt}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="min-w-0">
            <p className="font-medium text-foreground truncate">{customer?.name}</p>
            <p className="text-sm text-muted-foreground truncate">{customer?.email}</p>
          </div>
        </div>
      </td>
      <td className="px-4 md:px-6 py-4 md:py-5 hidden md:table-cell">
        <p className="text-sm text-foreground">{customer?.phone}</p>
      </td>
      <td className="px-4 md:px-6 py-4 md:py-5">
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium ${getStatusColor(customer?.projectStatus)}`}>
          {customer?.projectStatus?.charAt(0)?.toUpperCase() + customer?.projectStatus?.slice(1)}
        </span>
      </td>
      <td className="px-4 md:px-6 py-4 md:py-5 hidden lg:table-cell">
        <p className="text-sm text-foreground">{getAduTypeLabel(customer?.aduType)}</p>
      </td>
      <td className="px-4 md:px-6 py-4 md:py-5 hidden lg:table-cell">
        <p className="text-sm text-muted-foreground">{formatDate(customer?.lastContact)}</p>
      </td>
      <td className="px-4 md:px-6 py-4 md:py-5">
        <button 
          className="min-w-[44px] min-h-[44px] flex items-center justify-center hover:bg-muted rounded-lg transition-colors duration-200"
          onClick={(e) => {
            e?.stopPropagation();
            onClick?.();
          }}
        >
          <Icon name="ChevronRight" size={18} className="text-muted-foreground" />
        </button>
      </td>
    </tr>
  );
};

export default CustomerTableRow;